import React, { Component, Fragment } from "react";
import MetaTags from "react-meta-tags";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import Breadcrumb from "../layouts/Breadcrumb";
import Clients from "../layouts/Clients";
import Content from "../sections/verify/Content";

class Verify extends Component {
  componentDidMount() {
    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
  }
  render() {
    return (
      <Fragment>
        <MetaTags>
          <title>Verify | Gems G9</title>
          <meta name="description" content="#" />
        </MetaTags>
        <Header viewEcommerce={true} />
        {/* <Breadcrumb breadcrumb={{pagename:'About'}} /> */}
        <Content />
        {/* <Clients/> */}
        <Footer />
      </Fragment>
    );
  }
}

export default Verify;
